(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-page-header"]) return;
  try {
    
  if (!customElements.get('collection-description')) {
    customElements.define('collection-description', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const content = this.querySelector('.collection-description__content');
        const button = this.querySelector('button');
        if (!content || !button) return;
        content.classList.add('is-collapsed');
        const updateOverflow = () => {
          if (button.getAttribute('aria-expanded') === 'false') {
            button.hidden = content.scrollHeight <= content.clientHeight + 1;
          }
        };
        button.addEventListener('click', () => {
          const expanded = button.getAttribute('aria-expanded') !== 'true';
          button.setAttribute('aria-expanded', String(expanded));
          content.classList.toggle('is-collapsed', !expanded);
          button.querySelector('[data-read-more]').hidden = expanded;
          button.querySelector('[data-read-less]').hidden = !expanded;
          if (!expanded) updateOverflow();
        });
        this.observer = new ResizeObserver(updateOverflow);
        this.observer.observe(content);
        updateOverflow();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.initialized = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
